import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useMenuAvailability(pollMs = 30000) {
  const [availability, setAvailability] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await axios.get(`${API}/menu/availability`);
      setAvailability(data || {});
    } catch {
      setAvailability({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    if (!pollMs) return;
    const t = setInterval(refresh, pollMs);
    return () => clearInterval(t);
  }, [pollMs]);

  const isAvailable = (itemId) => availability[itemId] !== false;
  return { availability, isAvailable, loading, refresh };
}
